import { IActionBase, IMailTemplatesState,   } from "../models/root.interface";
import { ADD_MAIL_TEMPLATE, CLEAR_MAIL_TEMPLATES } from "../actions/Mailtemplates.action";


const initialState: IMailTemplatesState = {
    MailTemplates: []
};
function MailTemplatesReducer(state: IMailTemplatesState = initialState, action: IActionBase): IMailTemplatesState {
    switch (action.type) {
        case ADD_MAIL_TEMPLATE: {
            let maxId: number= Math.max.apply(Math, state.MailTemplates.map(o =>  o.id));
            if(maxId === -Infinity) { maxId = 0; }
            let newItem = {
                id: maxId + 1,
                template_Id:action.template_Id,
                channelId: action.channelId,
                name: action.name,
                status: action.status,
            };
            return {...state, MailTemplates: [...state.MailTemplates, newItem]};
        }
        case CLEAR_MAIL_TEMPLATES:
            return {...state, MailTemplates: []};
        default:
            return state;
    }
}


export default MailTemplatesReducer;